import { useContext} from 'react'
import Footer from '../../Components/Footer/Footer'
import './credits.scss'
import Theme from '../../Components/Theme/Theme'
import Sound from '../../Components/Sound/Sound'
import Language from '../../Components/Language/Language'
import SvgLoader from './SVGLoader'
import icons from './icons.json';
import Button from '../../Components/Button/Button'
import sounds from './sounds.json';
import {ReactComponent as Arrow} from '../../Assets/Svg/arrow.svg'
import LanguageContext from '../../Contexts/Language'
const Credits = () =>{
    const {language} = useContext(LanguageContext);
    return(
        <div className="credits-page">
            <Button className="back" onClick={() => {window.history.back()}}><Arrow/></Button>
            <div className="credits-inner">
                <div className="credits-header">{language.credits.title}</div>
                <div className="containers-wrapper">
                    <div className="container container-icons">
                    <div className="spacer">
                        <div className="spacer-text blur-background">
                           {language.credits.icons}
                        </div>
                        <div className="line"/>
                    </div>
                    {icons.map((icon, key) =>(
                        <div className="container-item" key={key}>
                            <SvgLoader fileName={`images/svg/${icon.icon}`}/>
                            <div className="item-author">{icon.author}</div>
                            <span>-</span>
                            <Button className="item-license" href={icon.licenseLink}>{icon.license}</Button>
                            <span>-</span>
                            <Button className="item-link" href={icon.link}>{icon.link.slice(8,32)}{icon.link.length > 32 ? "..." : ""}</Button>
                        </div>
                    ))}
                    </div>
                    <div className="container container-sounds">
                        <div className="spacer">
                            <div className="spacer-text blur-background">
                                {language.credits.sounds}
                            </div>
                            <div className="line"/>
                        </div>
                        {sounds.map((sound, key) =>(
                            <div className="container-item" key={key}>
                                <audio controls src={`sounds/${sound.sound}`}></audio>
                                <div className="item-author">{sound.author}</div>
                                <span>-</span>
                                <Button className="item-license" href={sound.licenseLink}>{sound.license}</Button>
                                <span>-</span>
                                <Button className="item-link" href={sound.link}>{sound.link.slice(8,32)}{sound.link.length > 32 ? "..." : ""}</Button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer/>
            <Theme/>
            <Sound/>
            <Language/>
        </div>
    )
}
export default Credits